
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  components: { VueSlickCarousel },
  data () {
    return {
      current: 0,
      length: 12,
      images: [
        {
          desktop: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_3_1920.jpg',
          tablet: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_3_768.jpg',
          mobile: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_3_380.jpg'
        },
        {
          desktop: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_6_1920.jpg',
          tablet: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_6_768.jpg',
          mobile: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_6_380.jpg'
        },
        {
          desktop: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_15_1920.jpg',
          tablet: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_15_768.jpg',
          mobile: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_15_380.jpg'
        },
        {
          desktop: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_10_1920.jpg',
          tablet: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_10_768.jpg',
          mobile: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_10_380.jpg'
        },
        {
          desktop: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_11_1920.jpg',
          tablet: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_11_768.jpg',
          mobile: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_11_380.jpg'
        },
        {
          desktop: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_14_1920.jpg',
          tablet: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_14_768.jpg',
          mobile: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_14_380.jpg'
        },
        {
          desktop: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_13_1920.jpg',
          tablet: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_13_768.jpg',
          mobile: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/about/hero_13_380.jpg'
        }
      ]
    };
  },
  methods: {
    updatePos (_o, n) {
      this.current = n;
    }
  }
};
